<template>
    <div class="md:pl-10 w-full md:w-3/4 md:pr-10">
        <h1 class="mt-2 mb-6 font-sans-bold">Event Logos</h1>
        <p class="mb-5">Logos are OPTIONAL. If you have a logo and/or logos for supporting or sponsoring organizations, upload them here and they will appear at the bottom of your event details page. You can include up to 10. Please use web-ready images sized at 500 pixels wide (height will be variable based on logo).</p>

        <div class="border-b border-grey-dark mb-10" v-for="(image, index) in form.images">
            <div class="mb-6 mr-2">
                <label class="hidden" for="image">
                    Image <span class="text-red">*</span>
                </label>
                <input v-validate="'required'" type="file" @change="processFile($event, index)" name="image">
                <span v-show="errors.has('image')" class="error text-error-red text-lg block">{{ errors.first('image') }}</span>
            </div>

            <div class="w-full mb-6 mr-2">
                <label for="url">
                    URL
                    <div class="text-sm font-sans-book">This will be the website the logo links to. Please provide a fully qualified URL - must include http:// or https:// (e.g., https://www.letsreimagine.com).</div>
                </label>
                <input
                    id="form.url" type="text" name="url"
                    v-model="form.images[index].url">
                <span v-show="errors.has('url')" class="error text-error-red text-lg">{{ errors.first('url') }}</span>
            </div>

            <div class="w-full mb-10 mr-2">
                <label for="title">
                    Title
                    <div class="text-sm font-sans-book">This is used for accessibility. We recommend using the name of the organization corresponding to the logo.</div>
                </label>
                <input
                    id="title" type="text" name="title"
                    v-model="form.images[index].title">
                <span v-show="errors.has('title')" class="error text-error-red text-lg">{{ errors.first('title') }}</span>
            </div>
        </div>

        <div class="mb-6 text-right" v-if="form.images.length < 10">
            <button class="button button__small"
                @click="addImage">Add Another Logo</button>
        </div>

        <div v-if="imagesExist">
            <h2 class="block font-sans-bold text-2xl text-black mb-2">Your Logos</h2>
            <table class="w-full mb-5">
                <thead>
                    <tr>
                        <th class="text-left p-2 border border-grey-light">Image</th>
                        <th class="text-left p-2 border border-grey-light">URL</th>
                        <th class="text-left p-2 border border-grey-light">Title</th>
                        <th class="text-left p-2 border border-grey-light">Action</th>
                    </tr>
                </thead>
                <tr v-for="image in images">
                    <td class="p-2 border border-grey-light">
                        <img :src="image.fullPath + '?auto=format&fit=scale&h=80'">
                    </td>
                    <td class="p-2 border border-grey-light">
                        {{ image.url }}
                    </td>
                    <td class="border border-grey-light">
                        {{ image.title }}
                    </td>
                    <td class="border border-grey-light">
                        <button @click.stop.prevent="deleteLogo(image.id)">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 100 100"><g><g transform="translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)" style="fill:#000000"><svg fill="#000000" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve"><rect x="33.1" y="38.8" width="5.6" height="45"></rect><rect x="47.2" y="38.8" width="5.6" height="45"></rect><rect x="61.2" y="38.8" width="5.6" height="45"></rect><path d="M86.6,16.2H66.9V5H33.1v11.2H13.4v16.9H19V95h61.9V33.1h5.6L86.6,16.2L86.6,16.2z M38.8,10.6h22.5v5.6H38.8V10.6z   M19.1,21.9h14.1H67h14.1v5.6h-62V21.9z M75.3,89.4H24.7V33.1h50.6V89.4z"></path></svg></g></g></svg>
                        </button>
                    </td>
                </tr>
            </table>
        </div>

        <div class="mb-6 text-right">
            <button class="button mr-4" @click.stop.prevent="save" :class="{ 'opacity-50 cursor-not-allowed': saving }" :disabled="saving">
                <template v-if="saving">Processing...</template>
                <template v-else>Save</template>
            </button>
            <button class="button" @click.stop.prevent="saveNext" :class="{ 'opacity-50 cursor-not-allowed': saving }" :disabled="saving">Save & Next</button>
        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import EventLogoItem from './EventLogoItem.vue'
    import eventSave from '../../../mixins/event-save'
    import messaging from '../../../mixins/messaging'

    export default {
        name: 'EventCreateLogos',
        components: {EventLogoItem},
        mixins: [eventSave, messaging],
        data: () => ({
            // images: [{}],
            form: {
                images: [{}]
            },
            next: 'events-tickets'
        }),
        watch: {
            event(event) {
                if( !_.isEmpty( event ) ) {

                    this.$nextTick(function () {
                        this.$store.dispatch('setUnsavedData', false)
                    })
                }
            }
        },
        computed: {
            ...mapGetters({
                event: 'event',
            }),
            images() {
                return this.event.logos
            },
            imagesExist() {
                return (this.images) ? this.images.length > 0 : false
            }
        },
        methods: {
            processFile(e, index) {
                if (!e.target.files.length) {
                    return;
                }

                const file = e.target.files[0];

                let reader = new FileReader();
                // let vm = this;

                reader.onload = (e) => {
                    let contents = e.target.result;
                    const name = file.name;

                    this.form.images[index].image = {
                        contents: btoa(contents),
                        name: name
                    }

                }
                // readAsBinaryString
                reader.readAsBinaryString(file);
            },
            addImage() {
                this.form.images.push({})
            },

            deleteLogo(id) {

                this.saving = true
                this.$toasted.show('The logo is being deleted')

                let route = this.$laroute.route('api.events.delete.logos', {
                    event: this.event.id,
                    logo: id
                })

                _.remove(this.form.images, function(image) {
                  return image.id == id
                });

                axios.delete(route).then((response) => {

                    this.systemSave()

                    const id = this.$route.params.id
                    this.$store.dispatch('getEvent', {id: id})
                    this.$store.dispatch('setUnsavedData', false)
                }).catch((error) => {
                    this.displayError(error)
                })
            },

            editLogo(id) {
                this.$router.push({name: 'events-logos-edit', params: {id: id}})
            },

            save() {

                this.saving = true

                return this.$validator.validateAll().then((result) => {
                    if (!result) {
                        this.saving = false
                        return;
                    }

                    return this.systemSave()
                })
            },

            systemSave() {
                this.$toasted.show('Event currently saving...')

                let route = this.$laroute.route('api.events.update.logos', { event: this.event.id })

                return axios.put(route, this.form).then((response) => {
                    this.showUpdatedToast()
                    this.saving = false

                    const id = this.$route.params.id
                    this.$store.dispatch('getEvent', {id: id})
                    this.$store.dispatch('setEventHasErrors', false)
                    this.resetForm()

                }).catch((error) => {
                    this.displayError(error)
                })
            },

            resetForm() {
                this.form.images = [{}]
            }
        },
        mounted() {
            const id = this.$route.params.id
            this.$store.dispatch('getEvent', {id: id})
            document.getElementById("dropdown").checked = false;
        }
    }
</script>
